import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    card: {
      boxShadow: 'none',
    },
    cardHeaderRoot: {
      paddingBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
    },
    cardHeaderContent: {
      display: 'flex',
      alignItems: 'center',
      minHeight: theme.spacing(3),
    },
    cardBody: {
      padding: theme.spacing(0, 2, 5, 2),
    },
    cardActions: {
      marginRight: 0,
      '@media(min-width: 600px)': {
        marginRight: 0,
      },
    },
    photoSpacer: {
      marginBottom: -25, // hack for photo layout
    },
    placeholder: {
      minHeight: theme.spacing(18),
      paddingTop: theme.spacing(2),
      marginLeft: -theme.spacing(1) * 2,
      marginRight: -theme.spacing(1) * 2,
    },
    unavailable: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: theme.spacing(18),
      paddingTop: theme.spacing(2),
    },
    button: {
      padding: 0,
      minHeight: 'auto',
      color: theme.custom.palette.grey1,
    },
    photo: {
      marginBottom: theme.spacing(2),
    },
    align: {
      textAlign: 'center',
    },
    cardPaper: {
      borderTop: 'none',
      marginBottom: theme.spacing(1),
    },
    chooseImage: {
      paddingTop: theme.spacing(2),
    },
    chooseImageTitle: {
      paddingBottom: theme.spacing(0.5),
    },
    uploadButton: {
      width: '90px',
      height: '72px',
    },
    uploadButtonText: {
      fontSize: 11,
    },
    buttonLabel: {
      flexDirection: 'column',
    },
  });

export default styles;
